import utils from "../utils.mjs";
function isAxiosError(payload) {
  return utils.isObject(payload) && payload.isAxiosError === true;
}
export {
  isAxiosError as default
};
